/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable lines-between-class-members */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-use-before-define */
import * as React from 'react';
import {
  Box, Snackbar,
} from '@mui/material';
import MuiAlert, { AlertProps } from '@mui/material/Alert';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>((
  props,
  ref,
) => <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />);

export type tipoSnackbarAlert = 'success' | 'error' | 'warning' | 'info';
const tipoLocalSnackbarAlert: tipoSnackbarAlert = 'success';
class SnackbarAlertType {
  status: boolean = false;
  msg: string = '';
  tipo: tipoSnackbarAlert = 'success';
  open: (msg: string) => void = (msg: string) => {};
  close: () => void = () => {};
};

// Factory function that returns a new function that uses Hooks API.
function createHookSnackbarAlertUseState() {
  return function useHook() {
    const [openSnackbarAlert, setOpenSnackbarAlert] = React.useState({
      status: false,
      msg: '',
      tipo: tipoLocalSnackbarAlert,
      open: (msg: string, tipoSnackbar: tipoSnackbarAlert) => setOpenSnackbarAlert((prevState) => (
        {
          ...prevState, tipo: tipoSnackbar, msg, status: true,
        }
      )),
      close: () => setOpenSnackbarAlert((prevState) => (
        {
          ...prevState, tipo: tipoLocalSnackbarAlert, msg: '', status: false,
        }
      )),
    });

    return openSnackbarAlert;
  };
};

export const SnackbarAlertUseState = createHookSnackbarAlertUseState();

interface propsType {
  open: boolean;
  handleClose: () => void;
  message: string;
  tipo: tipoSnackbarAlert;
};

export const SnackbarAlert = ({
  open, handleClose, message, tipo,
}:propsType): JSX.Element => {
  const handleCloseLocal = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    handleClose();
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Snackbar open={open} autoHideDuration={3500} onClose={handleCloseLocal}>
        <Alert
          onClose={handleCloseLocal}
          severity={tipo}
          sx={{ width: '100%' }}
        >
          {message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

// const [open, setOpen] = React.useState(false);

// const handleClick = () => {
//   setOpen(true);
// };
